module.exports = __webpack_public_path__ + "static/media/Ad-Server-Dashboard-4.24e405d6.jpg";